function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m68.339 14.883 44.778 44.778a6.123 6.123 0 0 1 0 8.678L68.34 113.117a6.123 6.123 0 0 1-8.678 0L14.883 68.34a6.123 6.123 0 0 1 0-8.678L59.66 14.883a6.123 6.123 0 0 1 8.678 0",
    className: "icon_svg__black",
    style: {
      opacity: 1,
      strokeOpacity: 1,
      fillOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeMiterlimit: 4,
      strokeWidth: 32.581790506,
      fill: "#ffc304"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.179 54.37V89.93h9.46v-26.1h18.27V54.37h-27.73",
    className: "icon_svg__white",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.553 71.129V47.072l20.833 12.029z",
    className: "icon_svg__white",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgIcon;